// Query-key helpers: graph-data invalidation (everything except the identity, account, user administration and server-meta queries) after a data_version change or a finished job.
import type { Query, QueryClient } from "@tanstack/react-query";

export const GRAPH_DATA_KEY = ["kg"] as const;

const NON_GRAPH_OPERATIONS = new Set(["metaGetMeta", "metaGetMe", "metaGetHealth", "metaGetReadiness"]);
const NON_GRAPH_PREFIXES = ["auth", "admin"];

function operationId(query: Query): string | null {
  const head = query.queryKey[0];
  if (head !== null && typeof head === "object" && "_id" in head && typeof head._id === "string") {
    return head._id;
  }
  return null;
}

export function isGraphDataQuery(query: Query): boolean {
  if (query.queryKey[0] === GRAPH_DATA_KEY[0]) {
    return true;
  }
  const id = operationId(query);
  return (
    id !== null &&
    !NON_GRAPH_OPERATIONS.has(id) &&
    !NON_GRAPH_PREFIXES.some((prefix) => id.startsWith(prefix))
  );
}

export async function invalidateGraphData(queryClient: QueryClient): Promise<void> {
  await queryClient.invalidateQueries({ predicate: isGraphDataQuery });
}
